import { KartenMarkdown } from '../lib/markdown.jsx'

/**
 * Bildmarken-Karte („image occlusion").
 *
 * Auf dem Bild liegen alle Masken des Satzes; gefragt ist die eine mit
 * Akzentrand. Umdrehen blendet genau diese Maske aus — nicht die anderen,
 * sonst wäre die nächste Karte des Satzes schon beantwortet.
 *
 * Die Masken stehen in Prozent der Bildkanten und liegen deshalb auf iPhone
 * und Desktop an derselben Stelle, ohne dass die Bildgröße bekannt sein muss.
 *
 * Das Ausblenden folgt der einen choreografierten Bewegung aus DESIGN.md:
 * 180ms `ease-out`, und die Antwort steigt dabei 8px auf.
 */
export function BildKarte({ karte, umgedreht }) {
  const masken = Array.isArray(karte.masks) ? karte.masks : []
  const gefragt = Number(karte.asked ?? 0)
  const frage = karte.front_md ?? karte.front ?? ''
  const antwort = karte.back_md ?? karte.back ?? ''
  const zusatz = karte.back_extra_md ?? karte.back_extra ?? ''

  return (
    <div class="bildkarte">
      {frage ? <KartenMarkdown class="kartentext__frage" text={frage} /> : null}

      <div class="bildkarte__buehne">
        <img class="bildkarte__bild" src={karte.image_url} alt="" draggable={false} />
        {masken.map((maske, i) => (
          <span
            key={i}
            aria-hidden="true"
            class={[
              'bildkarte__maske',
              i === gefragt ? 'bildkarte__maske--gefragt' : '',
              i === gefragt && umgedreht ? 'bildkarte__maske--offen' : '',
            ]
              .filter(Boolean)
              .join(' ')}
            style={{
              left: `${maske.x}%`,
              top: `${maske.y}%`,
              width: `${maske.w}%`,
              height: `${maske.h}%`,
            }}
          />
        ))}
      </div>

      {umgedreht ? (
        <div class="kartentext__antwort-block">
          <KartenMarkdown class="kartentext__antwort" text={antwort} />
          {zusatz ? <KartenMarkdown class="kartentext__zusatz" text={zusatz} /> : null}
        </div>
      ) : null}
    </div>
  )
}
